import React, { useState, useEffect } from 'react';
import './GuestsAdmin.css';
import { FaTimes, FaClock, FaCheck, FaSearch, FaTrash } from 'react-icons/fa';
import useFormContext from './useFormAdminContext.js';
import Popup from 'reactjs-popup';
import Logo from './logo.png';
import ConfirmationModalDecline from "../GetEventMarsComplete.jsx/ConfirmationModal";
import ConfirmationModalAccept from "../GetEventMarsComplete.jsx/ConfirmationModalAccept";
import ConfirmationModalTentative from "../GetEventMarsComplete.jsx/ConfirmationModalTentative";

const GuestsAdmin = ({ isEditing }) => {
  const {
    handleGuestData,
    guestDetails,
    ProcessEventInvitation,
    familyUsers,
    addUser,
    user,
    setUser,
    removeUser,
    eventFormData,
    mltUsers,
    setEventFormData,
  } = useFormContext();

  useEffect(() => {
    handleGuestData();
  }, []);

  const [modalGuest, setModalGuest] = useState();
  const [isDeclineModalOpen, setIsDeclineModalOpen] = useState(false);
  const [isAcceptModalOpen, setIsAcceptModalOpen] = useState(false);
  const [isTentativeModalOpen, setIsTentativeModalOpen] = useState(false);

  const validateField = (id, value) => {
    let error = "";
    if (id === "familyNum") {
      if (value < 1) {
        error = "Minimum value is 1";
      }
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      [id]: error,
    }));
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setEventFormData((prevFormData) => ({
      ...prevFormData,
      [id]: value,
    }));
    validateField(id, value);

  };

  const isGuestsEditable = () => {
    return eventFormData.eventStatus !== 'Pending documentation'
      && eventFormData.eventStatus !== 'Completed'
      && eventFormData.eventStatus !== 'Cancelled';
  }

  const [errors, setErrors] = useState({});


    //for decline invitation
  const handleDeclineSaveClick = (guest, comment) => {
    ProcessEventInvitation(guest, "Declined", comment);
    setIsDeclineModalOpen(false);
  };

  const handleDeclineCancelClick = (e) => {
    e.preventDefault();
    setIsDeclineModalOpen(false);
  };

  // for accept invitation

  const handleAcceptSaveClick = (guest, comment) => {
    ProcessEventInvitation(guest, "Confirmed", comment);
    setIsAcceptModalOpen(false);
  };

  const handleAcceptCancelClick = (e) => {
    e.preventDefault();
    setIsAcceptModalOpen(false);
  };

  // for tentative invitation

  const handleTentativeSaveClick = (guest, comment) => {
    ProcessEventInvitation(guest, "Tentative", comment);
    setIsTentativeModalOpen(false);
  };

  const handleTentativeCancelClick = (e) => {
    e.preventDefault();
    setIsTentativeModalOpen(false);
  };

return (
    <>
      <div className="main-container col-md-10">
        <div className="overview-section">
          <div className="overview">
            <span>OVERVIEW</span>
            <div className="status">
              <div className="status-item">
                <span className="under-review">UNDER REVIEW</span>
                <span id="UnderReviewCount" className="count">
                  {guestDetails.UnderReview}
                </span>
              </div>
              <div className="status-item">
                <span className="Confirmed">CONFIRMED</span>
                <span id="ConfirmedCount" className="count">
                  {guestDetails.Confirmed}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="content">
          <div className="family-guests">
            <div className="family-header">
              <span>MARS FAMILY GUESTS</span>
            </div>
            <div className="form-group row mb-2">
              <label className="custom-font col-sm-3 col-form-label">NUMBER OF SEATS REQUESTED</label>
              <div className="col-sm-2">
                <input type="text"
                  className={`custom-font-lt ${isEditing ? 'form-control' : 'form-control-plaintext disabled'}`}
                  id={eventFormData.mltEvent === true ? "mltNum" : "familyNum"}
                  value={
                    eventFormData.mltEvent === true
                      ? eventFormData.mltNum
                      : eventFormData.familyNum
                  }
                  onChange={handleInputChange} />
              </div>
              {errors.familyNum && (
                <div className="col-sm-4" style={{ color: "red", fontSize: "13px" }}>
                  {errors.familyNum}
                </div>
              )}
            </div>
            <div className="guest-list" id="guestItem">
              {guestDetails.guests.map((guest, index) => (
                <div className="guest-item" key={index}>
                  <div className="guest-name">{guest.name}</div>
                  <div className="guest-actions">
                    <button
                      id={'Declined' + guest.name}
                      className={`btn-remove ${guest.status === 'Declined' ? 'Declined' : ''}`}
                      style={{cursor: (guest.status === 'Declined') ? "default" : "pointer"}}
                      disabled={guest.status === 'Declined'}
                      onClick={(e) => {
                        e.preventDefault();
                        if (isGuestsEditable())
                          setModalGuest(guest);
                          setIsDeclineModalOpen(true);
                      }}
                    >
                      <FaTimes />
                    </button>
                    <button
                      id={'Tentative' + guest.name}
                      className={`btn-timer ${guest.status === 'Tentative' ? 'Tentative' : ''}`}
                      style={{cursor: (guest.status === 'Tentative') ? "default" : "pointer"}}
                      disabled={guest.status === 'Tentative'}
                      onClick={(e) => {
                        e.preventDefault();
                        if (isGuestsEditable())
                          setModalGuest(guest);
                          setIsTentativeModalOpen(true);
                      }}
                    >
                      <FaClock />
                    </button>
                    <button
                      id={'Confirmed' + guest.name}
                      className={`btn-confirm ${guest.status === 'Confirmed' ? 'Confirm' : ''}`}
                      style={{cursor: (guest.status === 'Confirmed') ? "default" : "pointer"}}
                      disabled={guest.status === 'Confirmed'}
                      onClick={(e) => {
                        e.preventDefault();
                        if (isGuestsEditable())
                          setModalGuest(guest);
                          setIsAcceptModalOpen(true);
                      }}
                    >
                      <FaCheck />
                    </button>
                    {isGuestsEditable() && (
                      <button
                        id={'Deleted' + guest.name}
                        className={"btn-delete"}
                        onClick={(e) => {
                          e.preventDefault();
                          removeUser(guest);
                        }}
                      >
                        <FaTrash />
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {isGuestsEditable() && (
              <div className="add-member" id="addMember">
                <span>ADD A MEMBER</span>
                <input
                  readOnly
                  type="text"
                  id="AddMemberText"
                  value={user?.fullname}
                  placeholder={!isEditing ? "" : "Search any person to add as a guest"}
                />
                <Popup
                  trigger={<div id="btnSearch" className="btn-search"><FaSearch /></div>}
                  position="right center"
                  arrow={false}
                >
                  <div className="popup" id="userPopup" style={{ position: 'fixed', top: '50%', left: '50%', width: '25%', height: '75%', overflowY: 'scroll' }}>
                    <div className="container-fluid justify-content-between">
                      <div className="d-flex align-items-center">
                        <a className="navbar-brand mb-0" href="#">
                          <img src={Logo} alt="Logo" width="100" className="d-inline-block align-text-top" />
                        </a>
                        <a
                          className="close-btn"
                          style={{ textDecoration: 'none' }}
                          onClick={(e) => {
                            e.preventDefault();
                            document.getElementById('userPopup').style.display = 'none';
                          }}
                        >
                          ×
                        </a>
                      </div>
                    </div>
                    <div className="content" style={{ height: 400 }}>
                      {(eventFormData.mltEvent ? mltUsers : familyUsers).map((user) => (
                        <div className="guest-item" key={user.id}>
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              setUser(user);
                              document.getElementById('userPopup').style.display = 'none';
                            }}
                          >
                            {user.fullname}
                          </a>
                          <br />
                        </div>
                      ))}
                    </div>
                  </div>
                </Popup>
                <button id="btnSearch" className="btn-search" style={{ zIndex: 1000 }} onClick={(e) => { e.preventDefault(); addUser(user); }}>
                  <FaCheck />
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <div style={{ marginBottom: "100px" }}></div>
        <ConfirmationModalAccept
            isOpen={isAcceptModalOpen}
            onClose={() => setIsAcceptModalOpen(false)}
            onSave={(comment) => handleAcceptSaveClick(modalGuest,comment)}
            onCancel={handleAcceptCancelClick}
            commentMandatory={true}
            placeHolderText="I accept this invitation on behalf of the guest."
        />
        <ConfirmationModalTentative
            isOpen={isTentativeModalOpen}
            onClose={() => setIsTentativeModalOpen(false)}
            onSave={(comment) => handleTentativeSaveClick(modalGuest,comment)}
            onCancel={handleTentativeCancelClick}
            commentMandatory={true}
            placeHolderText="I might accept this invitation on behalf of the guest."
        />
        <ConfirmationModalDecline
            isOpen={isDeclineModalOpen}
            onClose={() => setIsDeclineModalOpen(false)}
            onSave={(comment) => handleDeclineSaveClick(modalGuest,comment)}
            onCancel={handleDeclineCancelClick}
            commentMandatory={true}
            placeHolderText="I decline this invitation on behalf of the guest."
        />
    </>

  );
};

export default GuestsAdmin;